/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { LexplusTagKontextEnum } from '../../models/lexplus-tag-kontext-enum';
import { LexplusTagMiniDto } from '../../models/lexplus-tag-mini-dto';

export interface TagsControllerDetachV1$Params {
  kontextID: number;
  tagID: string;
  kontext: LexplusTagKontextEnum;
}

export function tagsControllerDetachV1(http: HttpClient, rootUrl: string, params: TagsControllerDetachV1$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<LexplusTagMiniDto>>> {
  const rb = new RequestBuilder(rootUrl, tagsControllerDetachV1.PATH, 'delete');
  if (params) {
    rb.path('kontextID', params.kontextID, {});
    rb.path('tagID', params.tagID, {});
    rb.path('kontext', params.kontext, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<LexplusTagMiniDto>>;
    })
  );
}

tagsControllerDetachV1.PATH = '/v1/tags/{kontext}/{kontextID}/{tagID}';
